import cardIcon from 'assets/pics/icons/paymentMethods/credit-card.svg';
import googlePayIcon from 'assets/pics/icons/paymentMethods/google-pay.svg';
import paypalIcon from 'assets/pics/icons/paymentMethods/paypal.svg';
import applePayIcon from 'assets/pics/icons/paymentMethods/apple-pay.svg';
import directDebitIcon from 'assets/pics/icons/paymentMethods/direct-debit.svg';
import idealIcon from 'assets/pics/icons/paymentMethods/ideal.svg';
import amazonIcon from 'assets/pics/icons/paymentMethods/amazon.svg';
import rokuIcon from 'assets/pics/icons/paymentMethods/roku.svg';
import wirecardIcon from 'assets/pics/icons/paymentMethods/wirecard.svg';

export const paymentMethods = {
  Card: cardIcon,
  'Google In-App': googlePayIcon,
  PayPal: paypalIcon,
  'Apple In-App': applePayIcon,
  'Direct Debit': directDebitIcon,
  Ideal: idealIcon,
  'Amazon In-App': amazonIcon,
  'Roku In-App': rokuIcon,
  Wirecard: wirecardIcon,
};
